import { DetailsResponse } from "../models/ResponseModels/DetailsResponse";
import { DetailFieldConfig } from "../Utilities";

export const workOrderDetailsSections: DetailFieldConfig<DetailsResponse>[] = [
  { id: "title", label: "Title:", key: "title" },
  { id: "channel", label: "Channel:", key: "channel" },
  { id: "programme", label: "Programme:", key: "programme" },
  { id: "series", label: "Series Number:", key: "series" },
];
